module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/access_main-visual-f25998e7395e40d7f8adeac4716ef99b.jpg";